import { PURCHASE_POINTS_VALIDITY_NOTICE } from "@/features/purchasePoints/config/purchasePoints.config";

export const PurchasePointsValidityNotice = () => (
  <p className="mb-4 text-sm text-gray-600 dark:text-gray-300" data-testid="purchase-points-validity-notice">
    {PURCHASE_POINTS_VALIDITY_NOTICE}
  </p>
);

PurchasePointsValidityNotice.displayName = "PurchasePointsValidityNotice";
